module.exports = __webpack_public_path__ + "img/cover.8c3cf80d.png";